import { render, staticRenderFns } from "./MarcaList.vue?vue&type=template&id=43ea1d0c&scoped=true&"
import script from "./MarcaList.vue?vue&type=script&lang=js&"
export * from "./MarcaList.vue?vue&type=script&lang=js&"
import style0 from "./MarcaList.vue?vue&type=style&index=0&id=43ea1d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ea1d0c",
  null
  
)

export default component.exports